import React from 'react';
import { useTranslation } from 'react-i18next';
import './BufferDelayInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const BufferDelayInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  options.push({ text: `0 seconds`, value: '0' });
  options.push({ text: `0.5 seconds`, value: '0.5' });
  options.push({ text: `1 second`, value: '1' });

  for (let i = 1.5; i <= 10; i += 0.5) {
    options.push({ text: `${i} seconds`, value: i.toString() });
  }

  const onChange = (option: Option) => {
    if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
      updateStream({
        transcoderBufferDelay: parseFloat(option.value),
      });
    } else {
      updateEncoder(project.encoder, {
        transcoderBufferDelay: parseFloat(option.value),
      });
    }
  };

  return (
    <div className="buffer-delay-input">
      <div className="input-title">
        {t('producer.inputs.buffer-delay.title')}
        <Help
          title="Video Start Delay"
          text="Creates a buffer at the start of your live stream to align captions more accurately. Adjusting ensures that captions are in sync with video in real-time.<br/><br/>Increase this value if captions are delivered by a slower input, e.g. slower speakers."
        />
      </div>
      <Dropdown
        value={project.encoder.transcoderBufferDelay.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.buffer-delay.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.buffer-delay.footer')}</div>
    </div>
  );
};

export default React.memo(BufferDelayInput);
